import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label"];
import React from 'react';
import { FormattedInput } from '../FormattedInput/FormattedInput';

/**
 * `InputSSNLastFour` proactively eliminates errors by restricting and formatting data to
 * align with user expectations and business requirements.
 */
export var InputSSNLastFour = function InputSSNLastFour(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Last 4 digits of SSN' : _ref$label,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FormattedInput, _extends({
    label: label
  }, otherProps, {
    format: "####",
    placeholder: "0000",
    type: "tel",
    small: true
  }));
};